<div fxLayout="column" fxLayoutAlign="center center" style="height: 100%">
  <mat-icon style="font-size: 150px; height: 150px; width: 150px"
    ><img [id]="iconID"
  /></mat-icon>
  <p class="mat-headline-2" style="text-align: center">{{ errorCode }}</p>
  <p class="mat-headline-2" style="text-align: center">{{ frenchText }}</p>
  <p class="mat-headline-2" style="text-align: center">{{ englishText }}</p>
</div>
